import script from "./templatePreview.vue?vue&type=script&lang=js"
export * from "./templatePreview.vue?vue&type=script&lang=js"

import "./templatePreview.vue?vue&type=style&index=0&id=2b270ab1&lang=css"

const __exports__ = script;

export default __exports__